(() => {
  const openShareBtns = document.querySelectorAll('.js--open-share');
  const closeShareBtns = document.querySelectorAll('.js--close-share');
  const copyBtn = document.querySelector('.js--copy-link');
  const shareInput = document.getElementById('share-url');

  const copyContent = () => {
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      const oldContentEditable = shareInput.contentEditable;
      const oldReadOnly = shareInput.readOnly;
      const range = document.createRange();
      shareInput.contentEditable = true;
      shareInput.readOnly = false;
      range.selectNodeContents(shareInput);
      const s = window.getSelection();
      s.removeAllRanges();
      s.addRange(range);
      shareInput.setSelectionRange(0, 999999);
      shareInput.contentEditable = oldContentEditable;
      shareInput.readOnly = oldReadOnly;
    } else {
      shareInput.select();
    }
    document.execCommand('copy');
    document.body.classList.add('is-copied');
  };

  copyBtn.addEventListener('click', () => {
    copyContent();
  });

  for (let i = 0; i < openShareBtns.length; i++) {
    const openBtn = openShareBtns[i];
    openBtn.addEventListener('click', () => {
      document.body.classList.add('is-share');
    });
  }

  for (let i = 0; i < closeShareBtns.length; i++) {
    const closeBtn = closeShareBtns[i];
    closeBtn.addEventListener('click', () => {
      document.body.classList.remove('is-share');
      document.body.classList.remove('is-copied');
    });
  }
})();
